__turbopack_context__.v({
  "active": "order-module-scss-module__ElsUaa__active",
  "addressBlock": "order-module-scss-module__ElsUaa__addressBlock",
  "audPriceMessage": "order-module-scss-module__ElsUaa__audPriceMessage",
  "bagsHd": "order-module-scss-module__ElsUaa__bagsHd",
  "bagsItemEdit": "order-module-scss-module__ElsUaa__bagsItemEdit",
  "bagsItemImg": "order-module-scss-module__ElsUaa__bagsItemImg",
  "bagsItemInfo": "order-module-scss-module__ElsUaa__bagsItemInfo",
  "bagsItemInst": "order-module-scss-module__ElsUaa__bagsItemInst",
  "bagsItemOuter": "order-module-scss-module__ElsUaa__bagsItemOuter",
  "bagsItemPrice": "order-module-scss-module__ElsUaa__bagsItemPrice",
  "bagsItemRemove": "order-module-scss-module__ElsUaa__bagsItemRemove",
  "bagsItemSubtitle": "order-module-scss-module__ElsUaa__bagsItemSubtitle",
  "bagsItemTitle": "order-module-scss-module__ElsUaa__bagsItemTitle",
  "black-bt": "order-module-scss-module__ElsUaa__black-bt",
  "btnCustom": "order-module-scss-module__ElsUaa__btnCustom",
  "causeImg": "order-module-scss-module__ElsUaa__causeImg",
  "causeText": "order-module-scss-module__ElsUaa__causeText",
  "changeTp": "order-module-scss-module__ElsUaa__changeTp",
  "checkBox": "order-module-scss-module__ElsUaa__checkBox",
  "checkmark": "order-module-scss-module__ElsUaa__checkmark",
  "checkoutBlock": "order-module-scss-module__ElsUaa__checkoutBlock",
  "checkoutRadio": "order-module-scss-module__ElsUaa__checkoutRadio",
  "colorOrange": "order-module-scss-module__ElsUaa__colorOrange",
  "cupponBlock": "order-module-scss-module__ElsUaa__cupponBlock",
  "dayHd": "order-module-scss-module__ElsUaa__dayHd",
  "deliverFormBlock": "order-module-scss-module__ElsUaa__deliverFormBlock",
  "deliverInfoBlock": "order-module-scss-module__ElsUaa__deliverInfoBlock",
  "deliverInfoSeparator": "order-module-scss-module__ElsUaa__deliverInfoSeparator",
  "deliverTab": "order-module-scss-module__ElsUaa__deliverTab",
  "deliveryAddress": "order-module-scss-module__ElsUaa__deliveryAddress",
  "deliveryOptions": "order-module-scss-module__ElsUaa__deliveryOptions",
  "destinationHd": "order-module-scss-module__ElsUaa__destinationHd",
  "displayAdd": "order-module-scss-module__ElsUaa__displayAdd",
  "goodCausePage": "order-module-scss-module__ElsUaa__goodCausePage",
  "groupPosition": "order-module-scss-module__ElsUaa__groupPosition",
  "image": "order-module-scss-module__ElsUaa__image",
  "marginTp10": "order-module-scss-module__ElsUaa__marginTp10",
  "moreInfo": "order-module-scss-module__ElsUaa__moreInfo",
  "noCause": "order-module-scss-module__ElsUaa__noCause",
  "noDrop": "order-module-scss-module__ElsUaa__noDrop",
  "numberIcon": "order-module-scss-module__ElsUaa__numberIcon",
  "orderTotal": "order-module-scss-module__ElsUaa__orderTotal",
  "paymentCardBox": "order-module-scss-module__ElsUaa__paymentCardBox",
  "paymentDetailsBlock": "order-module-scss-module__ElsUaa__paymentDetailsBlock",
  "paymentDetailsCart": "order-module-scss-module__ElsUaa__paymentDetailsCart",
  "paymentSubtotalList": "order-module-scss-module__ElsUaa__paymentSubtotalList",
  "paymentTotalList": "order-module-scss-module__ElsUaa__paymentTotalList",
  "paymentVia": "order-module-scss-module__ElsUaa__paymentVia",
  "placeOrder": "order-module-scss-module__ElsUaa__placeOrder",
  "radioFree": "order-module-scss-module__ElsUaa__radioFree",
  "radioHd": "order-module-scss-module__ElsUaa__radioHd",
  "radioInfo": "order-module-scss-module__ElsUaa__radioInfo",
  "recipientAddress": "order-module-scss-module__ElsUaa__recipientAddress",
  "recipientName": "order-module-scss-module__ElsUaa__recipientName",
  "recipientTp": "order-module-scss-module__ElsUaa__recipientTp",
  "retailerGoodCauseDetails": "order-module-scss-module__ElsUaa__retailerGoodCauseDetails",
  "selectAdd": "order-module-scss-module__ElsUaa__selectAdd",
  "selectbox": "order-module-scss-module__ElsUaa__selectbox",
  "textOr": "order-module-scss-module__ElsUaa__textOr",
  "yourBagBlock": "order-module-scss-module__ElsUaa__yourBagBlock",
  "yourCauseBlock": "order-module-scss-module__ElsUaa__yourCauseBlock",
});
